import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function HintIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="12" cy="12" r="8" stroke="#BCBBD0" strokeWidth="2" />
			<path d="M12 12.0165L12 15.0714" stroke="#BCBBD0" strokeWidth="2" strokeLinecap="round" />
			<rect x="11.5" y="8.46948" width="1" height="1" rx="0.5" fill={props.fill} stroke="#BCBBD0" />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<HintIcon fill={props.fill} />
		</div>
	);
}